// pages/BlogPage.tsx
import React, { useEffect, useState } from 'react';
import BlogCard from '../components/BlogCard';
import { alertModal } from '../utils/modalController';
import Loader from '../components/Loader';
import { Col, Container, Row } from 'react-bootstrap';
import styles from './BlogPage.module.scss';

const apiUrl = process.env.REACT_APP_API_URL || '';

export const BlogPage = () => {
    const [posts, setPosts] = useState<BlogPostData[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Substitua pela sua API real
        fetch(`${apiUrl}/blog/posts`)
            .then(res => {
                if (!res.ok) {
                    throw new Error('Erro ao buscar posts');
                }
                return res.json();
            })
            .then(data => {
                setPosts(data); // ou data, se não estiver aninhado
            })
            .catch(err => {
                console.error('Erro:', err);
                alertModal('Erro ao buscar posts: ' + err.message);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    if (loading) return <Loader />;

    return (
        <Container className={["max-w-4xl", "mx-auto", "py-8", "px-4", styles['blog-page-container']].join(' ')}>
            <Row className="mb-4">
                <Col xs={12}>
                    {posts.length > 0 ? (
                        posts.map(post => (
                            <BlogCard
                                key={post.id}
                                title={post.title}
                                tags={post.tags ? post.tags : []}
                                excerpt={post.abstract || 'Sem resumo disponível.'}
                                date={new Date(post.createdAt).toLocaleDateString('pt-BR', {
                                    day: '2-digit',
                                    month: 'long',
                                    year: 'numeric',
                                })}
                                postUrl={`/blog/${post.id}`} // Ajuste conforme necessário
                                imageUrl={post.banner ? `${apiUrl}/blog/file/${post.banner}` : undefined} // Ajuste conforme necessário
                            />
                        ))
                    ) : (
                        <h1 className="text-center">Nenhum post encontrado.</h1>
                    )}
                </Col>
            </Row>
        </Container>
    );
};
